import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'LinkedCmsMst',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + 'マスタ | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'linkedCmsMstId',
        'linkedCmsName',
        'linkedCmsDomain',
        'linkedCmsStatus',
        'modifyButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          linkedCmsMstId: '連携CMS ID',
          linkedCmsName: '連携CMS名',
          linkedCmsDomain: '連携CMSドメイン',
          linkedCmsStatus: 'ステータス',
          modifyButton: ''
        },
        columnsClasses: {
          linkedCmsMstId: 'wp-5',
          linkedCmsName: '',
          linkedCmsDomain: '',
          linkedCmsStatus: '',
          modifyButton: 'wp-5 has-button'
        },
        sortable: [
          'linkedCmsMstId',
          'linkedCmsName',
          'linkedCmsDomain',
          'linkedCmsStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.linkedCmsMst.categoryName,
      linkedCmsMstModel: state => state.linkedCmsMst.linkedCmsMstModel,
      // form
      values: state => state.linkedCmsMst.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'linkedCmsMst/isRegister',
      isModify: 'linkedCmsMst/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.linkedCmsMstModel, 'linkedCmsMstUuid', this.modifyTargetId, 'linkedCmsMstId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpCmsName: {
      get () {
        return this.values.inpCmsName
      },
      set (value) {
        this.setInputValue({
          key: 'inpCmsName',
          value: value
        })
      }
    },
    inpCmsDomain: {
      get () {
        return this.values.inpCmsDomain
      },
      set (value) {
        this.setInputValue({
          key: 'inpCmsDomain',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // validate
    inpCmsNameIsValid () {
      return Validator.validText(this.inpCmsName)
    },
    inpCmsDomainIsValid () {
      return Validator.validText(this.inpCmsDomain)
    },
    inpStatusIsValid () {
      return Validator.validSelect(this.inpStatus)
    },
    formIsValid () {
      return this.inpCmsNameIsValid &&
        this.inpCmsDomainIsValid &&
        this.inpStatusIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'linkedCmsMst/loadModel',
      initRegister: 'linkedCmsMst/initRegister',
      initModify: 'linkedCmsMst/initModify',
    }),
    ...mapMutations({
      setInputValue: 'linkedCmsMst/setInputValue',
    }),

    init () {
      this.loading = true

      //TODO
      let linkedCmsMstParams = {}

      // データ読出し
      this.loadModel({
        linkedCmsMstParams: linkedCmsMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.linkedCmsMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.linkedCmsMstModel, 'linkedCmsMstUuid', this.modifyTargetId, 'linkedCmsMstId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true
      // console.log(this.isModify)
      let parameters = {
        request: {
          linkedCmsName: this.inpCmsName,
          linkedCmsDomain: this.inpCmsDomain,
          linkedCmsStatus: this.inpStatus
        }
      }
      if (this.isModify) {
        parameters.linkedCmsMstUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['linkedCmsMst'],
        [this.isRegister ?
          'v1LinkedCmsMstPost' :
          'v1LinkedCmsMstPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'linkedCmsStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.linkedCmsMstUuid
      this.initModify({
        data: props.row
      })
    },
  }
}